export default __webpack_public_path__ + "static/media/danji_cg_03_big.33d7299e.jpg";